import { BillingModel, type RecordPLESModel, UserModel } from "@doitintl/cmp-models";
import { getCollection } from "@doitintl/models-any";

import { consoleErrorWithSentry } from "../../utils/errorHandling";

export const getLastUpdate = async (): Promise<RecordPLESModel | null> => {
  try {
    const lastUpdateSnap = await getCollection(BillingModel)
      .doc("manualOperations")
      .collection("recordPles")
      .orderBy("createdAt", "desc")
      .limit(1)
      .get();

    return lastUpdateSnap.docs[0].asModelData();
  } catch (err) {
    consoleErrorWithSentry(err);
    return null;
  }
};

export const getUserDisplayName = async (email: string): Promise<string> => {
  try {
    const userQuery = await getCollection(UserModel).where("email", "==", email).limit(1).get();

    if (userQuery.empty) {
      return "";
    }

    return userQuery.docs[0].data()?.displayName ?? "";
  } catch (err) {
    consoleErrorWithSentry(err);
    return "";
  }
};
